(function(){
  function initFor(sel){
    var sec=document.querySelector(sel);
    if(!sec) return;
    var scroller=sec.querySelector('.image-link-blocks');
    var items=scroller?scroller.querySelectorAll('.image-link-blocks__item'):[];
    if(!scroller||items.length<2||sec.querySelector('.ar-dots')) return;
    var wrap=document.createElement('div'); wrap.className='ar-dots';
    wrap.setAttribute('role','tablist'); wrap.setAttribute('aria-label','Slides');
    var dots=[];
    items.forEach(function(it,i){
      var d=document.createElement('button'); d.type='button';
      d.setAttribute('aria-label','Go to slide '+(i+1));
      d.addEventListener('click',function(){ it.scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'}); });
      wrap.appendChild(d); dots.push(d);
    });
    scroller.insertAdjacentElement('afterend',wrap);
    function update(){
      var x=scroller.scrollLeft, w=items[0].getBoundingClientRect().width+20;
      var max=scroller.scrollWidth-scroller.clientWidth;
      /* narrow cards can't scroll the last item to the left edge, so index math
         never reaches the end - snap the last dot on when the scroller is maxed */
      var idx=(max-x<=2)?items.length-1:Math.min(items.length-1,Math.max(0,Math.round(x/w)));
      dots.forEach(function(d,i){ d.classList.toggle('on',i===idx); });
    }
    scroller.addEventListener('scroll',function(){ requestAnimationFrame(update); },{passive:true});
    update();
  }
  function init(){
    initFor('.shopify-section[id*="__benefits"]');
    initFor('.shopify-section[id*="__how_it_works"]');
  initFor('.shopify-section[id*="__modes"]');
  initFor('.shopify-section[id*="__fits_screen"]');
  initFor('.shopify-section[id*="__app_modes"]');
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
/* demo video primer - buffer all demo-carousel videos and start the active
   slide immediately (muted+playsinline permits it). */
(function(){
  function prime(){
    var sec=document.querySelector('.shopify-section[id*="__demo_carousel"]');
    if(!sec) return;
    var active=sec.querySelector('.slideshow__slide.is-selected video');
    if(active){ active.preload='auto'; if(active.paused){ active.play().catch(function(){}); } }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',prime); else prime();
  setTimeout(prime, 1200);
})();


/* ar-scroll-advance v3.2 (2026-08-03): multi-section. Same content-sized
   sticky mechanics as v3.1, applied to every section in SECTIONS. */
(function () {
  var SECTIONS = ['__benefits', '__how_it_works', '__fits_screen', '__app_modes'];
  var mq = window.matchMedia('(min-width: 700px) and (pointer: fine)');
  function findScroller(sec) {
    var els = sec.querySelectorAll('*');
    for (var i = 0; i < els.length; i++) {
      var el = els[i], cs = getComputedStyle(el);
      if (el.scrollWidth > el.clientWidth + 40 && /auto|scroll/.test(cs.overflowX)) return el;
    }
    return null;
  }
  var states = [];
  function measure() {
    states = [];
    for (var s = 0; s < SECTIONS.length; s++) {
      var sec = document.querySelector('.shopify-section[id*="' + SECTIONS[s] + '"]');
      if (!sec) continue;
      var child = null;
      for (var i = 0; i < sec.children.length; i++) {
        var t = sec.children[i].tagName;
        if (t !== 'STYLE' && t !== 'SCRIPT') { child = sec.children[i]; break; }
      }
      if (!child) continue;
      sec.classList.remove('ar-scrolljack');
      sec.style.minHeight = ''; child.style.top = '';
      if (!mq.matches) continue;
      var sc = findScroller(sec);
      if (!sc) continue;
      var kids = Array.prototype.filter.call(sc.children, function (k) { return k.offsetWidth > 0; });
      var n = kids.length;
      if (n < 2) continue;
      var ch = child.offsetHeight;
      var vh = window.innerHeight;
      var travel = Math.round((n - 1) * vh * 0.65);
      var topOff = Math.max(0, Math.round((vh - ch) / 2));
      sec.classList.add('ar-scrolljack');
      child.style.top = topOff + 'px';
      sec.style.minHeight = (ch + travel) + 'px';
      states.push({ sec: sec, sc: sc, kids: kids, n: n, travel: travel, topOff: topOff, base: kids[0].offsetLeft, cur: -1 });
    }
  }
  var ticking = false;
  function update() {
    ticking = false;
    for (var i = 0; i < states.length; i++) {
      var st = states[i];
      var r = st.sec.getBoundingClientRect();
      var p = Math.min(1, Math.max(0, (st.topOff - r.top) / st.travel));
      var idx = Math.round(p * (st.n - 1));
      if (idx !== st.cur) {
        st.cur = idx;
        st.sc.scrollTo({ left: st.kids[idx].offsetLeft - st.base, behavior: 'smooth' });
      }
    }
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });
  var rt = null;
  window.addEventListener('resize', function () {
    clearTimeout(rt); rt = setTimeout(function () { measure(); update(); }, 150);
  });
  function init() { measure(); update(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Layout isn't final at DOMContentLoaded (fonts/images/CSS still settling), so
  // the first measure can find no scroller and silently skip. Re-measure once
  // everything has loaded, and once more shortly after, to be certain.
  window.addEventListener('load', init);
  setTimeout(init, 900);
  mq.addEventListener ? mq.addEventListener('change', function () { measure(); }) : mq.addListener(function () { measure(); });
})();
